import { connect } from "react-redux";
import OvUrlResolver from "./OvUrlResolver";
import { setOverviewTab } from "./actions/route";
import queryString from "query-string";
import { setOverviewFilters } from "./actions/overviewParams";

const mapStateToProps = (state, ownProps) => {
  return {
    tabIndex: state.route.overviewTabIndex,
    labels: state.route.overviewTabLabels,
    monitoringMode: state.ui.focused
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    persistTab: index => {
      dispatch(setOverviewTab(index));
    },
    persistFilters: label => {
      const filters = queryString.parse(ownProps.history.location.search);
      dispatch(setOverviewFilters(filters, label));
    }
  };
};

const OvUrlResolverContainer = connect(mapStateToProps, mapDispatchToProps)(
  OvUrlResolver
);

export default OvUrlResolverContainer;



// WEBPACK FOOTER //
// ./src/OvUrlResolverContainer.js